import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, useTheme } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';

function DialogNovaObservacao(props) {
  const {
    filiado,
    setFiliado,
    abrirDialogObservacao,
    setAbrirDialogObservacao,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    novaObservacao,
    setNovaObservacao,
    edicao,
    setEdicao,
    indexModoEdicao,
    setIndexModoEdicao,
  } = props;
  const [refreshState, setRefreshState] = useState(new Date());
  const [erroTitulo, setErroTitulo] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  function aoModificarTitulo(event, valor) {
    event.preventDefault();
    novaObservacao.titulo = valor;
    setNovaObservacao(novaObservacao);
    setRefreshState(new Date());
    if (!valor) {
      setErroTitulo(true);
    }
    else {
      setErroTitulo(false);
    }
  }

  function aoModificarDescricao(event, valor) {
    event.preventDefault();
    console.log(valor.length);
    if (valor.length < 1500) {
      novaObservacao.descricao = valor;
      setNovaObservacao(novaObservacao);
      setRefreshState(new Date());
    }
  }

  function cancelar(event) {
    event.preventDefault();
    setNovaObservacao({ titulo: '', descricao: '' });
    setAbrirDialogObservacao(false);
  }

  function salvar(event) {
    try {
      console.log('oi');
      event.preventDefault();
      if (!novaObservacao.titulo) {
        setErroTitulo(true);
      }
      else {
        if(!edicao) {
          filiado.observacoes.push(novaObservacao);
          setFiliado(filiado);
          setNovaObservacao(null);
          setAbrirDialogObservacao(false);
          setTypeSnack('success');
          setMessageSnack('Observação adicionada com sucesso.');
          setShowMessageSnack(true);
        }
        else {
          filiado.observacoes[indexModoEdicao] = novaObservacao;
          setFiliado(filiado);
          setNovaObservacao(null);
          setAbrirDialogObservacao(false);
          setTypeSnack('success');
          setMessageSnack('Observação editada com sucesso.');
          setShowMessageSnack(true);
          setIndexModoEdicao(-1);
          setEdicao(false);
        }
      }
    }
    catch (e) {
      setTypeSnack('warning');
      setMessageSnack('Ocorreu um erro ao editar observação');
      setShowMessageSnack(true);
    }
  }

  return (
    <Dialog
      open={abrirDialogObservacao}
      aria-labelledby="form-dialog-title"
      onClose={e => cancelar(e)}
      fullScreen={fullScreen}
      maxWidth={'md'}
    >
      <DialogTitle id="form-dialog-title">Observação</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Para um nova observação, informe um título para fácil identificação
          e uma descrição, onde você pode ficar a vontade no preenchimento.
        </DialogContentText>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={12}
            xs={12}
          >
            <TextField
              fullWidth
              variant={'outlined'}
              inputProps={{ maxLength: 100 }}
              margin={'dense'}
              label={'Título'}
              helperText={'Informe um título para identificar facilmente sua observação.'}
              value={novaObservacao.titulo}
              onChange={e => aoModificarTitulo(e, e.target.value)}
              error={erroTitulo}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <TextField
              multiline
              rows={4}
              rowsMax={5}
              fullWidth
              variant={'outlined'}
              inputProps={{ maxLength: 1500 }}
              label={'Descrição'}
              helperText={'Fique à vontade para digitar o que for pertinente para essa observação.'}
              value={novaObservacao.descricao}
              onChange={e => aoModificarDescricao(e, e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={e => cancelar(e)}
        >
          CANCELAR
        </Button>
        <Button
          color="primary"
          variant={'contained'}
          onClick={e => salvar(e)}
        >
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogNovaObservacao.propTypes = {
  className: PropTypes.string,
  filiado: PropTypes.object.isRequired,
  abrirDialogObservacao: PropTypes.bool.isRequired,
  setAbrirDialogObservacao: PropTypes.any.isRequired,
  setFiliado: PropTypes.any.isRequired,
};

export default DialogNovaObservacao;


